import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PrivateConnectivityIcon(props: IconProps) {
    return <Icon {...props} iconKey={"private_connectivity"}/>
}
